// src/components/ThemeToggle.js
import React, { useState } from 'react';
import { useTheme } from '../../ThemeProvider';

import './ThemeToggle.css';
import { useLanguage } from '../../LanguageProvider';

const themes = ['root', 'light-theme', 'tron-theme','dark-theme'];

const ThemeToggle = () => {
    const { getTranslation } = useLanguage();
    const { theme, setTheme } = useTheme();
    const [isSpinning, setIsSpinning] = useState(false);

    const handleClick = () => {
        const currentIndex = themes.indexOf(theme);
        const nextTheme = themes[(currentIndex + 1) % themes.length];

        setIsSpinning(true);
        setTimeout(() => setIsSpinning(false), 800);

        setTheme(nextTheme);
    };

    return (
        <div
            className={`theme-toggle-border ${isSpinning ? 'spin' : ''}`}
            onClick={handleClick}
            title={getTranslation("changeTheme")}
        >
            <div className='theme-toggle-center'>

            </div>
        </div>
    );
};

export default ThemeToggle;
